<template>
  <div class="home">
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      title="Primeiro Acesso!"
      :visible.sync="changePassword"
    >
      <el-form ref="formPassword" :model="formPassword" :rules="rules">
        <el-form-item label="Senha atual" label-width="150px">
          <el-input
            v-model="formPassword.oldPassword"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="Nova senha" label-width="150px">
          <el-input
            v-model="formPassword.newPassword"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="Confirme nova senha" label-width="150px">
          <el-input
            v-model="formPassword.confirmPassword"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatePassword()"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <el-card shadow="always">
      <el-form :inline="true" :model="formInline">
        <el-form-item>
          <el-input
            v-model="filter"
            suffix-icon="el-icon-search"
            placeholder="Procurar por"
          ></el-input>
        </el-form-item>
        <el-form-item label="Contato" v-if="isAdmin">
          <el-input
            type="email"
            v-model="formInline.user"
            placeholder="E-mail contato"
          ></el-input>
        </el-form-item>
        <el-form-item label="Fornecedor">
          <el-input v-model="formInline.branch" placeholder="CNPJ"></el-input>
        </el-form-item>
        <el-form-item label="Filtrar por">
          <el-radio v-model="formInline.filterBy" label="1"
            >Data Emissão</el-radio
          >
          <el-radio v-model="formInline.filterBy" label="2"
            >Data Criação</el-radio
          >
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formInline.range"
            type="daterange"
            range-separator="à"
            start-placeholder="Inicio"
            end-placeholder="Fim"
            format="dd/MM/yyyy"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="fetchRecords()">Consultar</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 50px">
          <el-button type="primary" @click="add"
            >Registrar Nota Fiscal</el-button
          >

          <el-button type="success">
            <download-excel :fetch="fetchExcel" name="Relatorio.xls" type="xls">
              Relatório Excel
            </download-excel>
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table :data="pagedTableData" height="70vh" style="width: 100%">
      <el-table-column prop="status" label="Status de Integração">
        <template slot-scope="scope">
          <el-popover
            placement="left-start"
            title="Status da Nota"
            trigger="click"
            width="200"
            :content="scope.row.content"
          >
            <el-tag slot="reference" :type="scope.row.type" effect="dark">
              {{ scope.row.status }}
            </el-tag>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        prop="contentStatusPagamento"
        label="Status de Pagamento"
      >
        <template slot-scope="scope">
          <el-tag
            slot="reference"
            :type="scope.row.typeStatusPagamento"
            effect="dark"
          >
            {{ scope.row.contentStatusPagamento }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="federalId" label="CNPJ"></el-table-column>
      <el-table-column
        prop="federalName"
        label="Razão Social"
      ></el-table-column>
      <el-table-column prop="user.contact" label="Nome"></el-table-column>
      <el-table-column prop="invoice" label="N. Fiscal"></el-table-column>
      <el-table-column prop="serie" label="Serie"></el-table-column>
      <el-table-column prop="contact" label="Contato"></el-table-column>
      <el-table-column
        prop="issueAt"
        label="Data N. Fiscal"
        :formatter="formatter"
      ></el-table-column>
      <el-table-column
        prop="createdAt"
        label="Data Criação"
        :formatter="formatter"
      ></el-table-column>

      <el-table-column
        prop="request"
        label="Pedido de Compra"
      ></el-table-column>

      <el-table-column label="#">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.error && isAdmin"
            placement="top-start"
            title="Voltar status de integração"
            width="230"
            trigger="hover"
            content="Voltar status para A integrar."
          >
            <el-button
              slot="reference"
              size="mini"
              type="warning"
              @click="changeStatus(scope.row)"
            >
              <i class="el-icon-refresh"></i>
            </el-button>
          </el-popover>

          <el-popover
            placement="top-start"
            title="Alterar Nota"
            width="230"
            trigger="hover"
            content="Alterar informações da nota."
          >
            <el-button slot="reference" size="mini" @click="edit(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
          </el-popover>

          <el-popover
            placement="top-start"
            title="Deletar Nota"
            width="200"
            trigger="hover"
            content="Deletar a nota do banco."
          >
            <el-button
              slot="reference"
              size="mini"
              type="danger"
              @click="remove(scope.row)"
            >
              <i class="el-icon-delete"></i>
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { UserTypeEnum, UserService } from "../services/users/user.services";
import { InvoicesService } from "../services/invoices/invoices.services";
import ButtonComponent from "../components/ButtonComponent.vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "HomeView",
  components: {
    ButtonComponent
  },
  data() {
    const startAt = new Date();
    startAt.setDate(startAt.getDate() - 30);
    return {
      changePassword: false,
      name: "",
      formPassword: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "Campo obrigatório!",
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            message: "Campo obrigatório!",
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: "Campo obrigatório!",
            trigger: "blur"
          }
        ]
      },
      isAdmin: false,
      formInline: {
        branch: "",
        filter: "",
        filterBy: "1",
        user: "",
        range: [startAt, new Date()]
      },
      filter: "",
      tableData: [],
      excelData: []
    };
  },
  computed: {
    pagedTableData() {
      // tableData.filter(
      //   (data) =>
      //     !filter ||
      //     data.invoice === +filter ||
      //     data.serie
      //       .toLowerCase()
      //       .includes(
      //         filter.toLowerCase() ||
      //           data.branch.toLowerCase().includes(filter.toLowerCase())
      //       ) ||
      //     data.contact.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
      //     data.federalId.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
      //     data.federalName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
      //     data.status.toLowerCase().indexOf(filter.toLowerCase()) !== -1
      // )
      const vm = this;
      const myFilter = this.tableData.filter(
        data =>
          !this.filter ||
          data.invoice === +this.filter ||
          data.serie
            .toLowerCase()
            .includes(
              this.filter.toLowerCase() ||
                data.branch.toLowerCase().includes(this.filter.toLowerCase())
            ) ||
          data.contact.toLowerCase().indexOf(this.filter.toLowerCase()) !==
            -1 ||
          data.federalId.toLowerCase().indexOf(this.filter.toLowerCase()) !==
            -1 ||
          data.status.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1 ||
          (data.federalName
            ? data.federalName
                .toLowerCase()
                .indexOf(this.filter.toLowerCase()) !== -1
            : "")
      );

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      vm.excelData = myFilter;

      return myFilter;
    }
  },
  methods: {
    ...mapGetters("auth", ["getCompanyId"]),
    openPdf: function() {
      // eslint-disable-next-line no-undef
      let blob = new Blob([data], {
        type: "application/pdf"
      });
      // eslint-disable-next-line no-undef
      FileSaver.saveAs(blob, "invoice.pdf");
    },
    formatter(row, column) {
      return moment(row[column.property]).format("DD/MM/YYYY");
    },
    add: function() {
      const vm = this;
      vm.$router.push({ name: "invoice.add" });
    },
    updatePassword: function() {
      const vm = this;
      vm.$refs.formPassword.validate(valid => {
        if (valid) {
          if (vm.formPassword.newPassword !== vm.formPassword.confirmPassword) {
            return this.$message({
              type: "error",
              message: "Nova senha deve bater com a confirmação."
            });
          }
          UserService.profile(
            vm.name,
            vm.formPassword.newPassword,
            vm.formPassword.oldPassword
          )
            .then(() => {
              this.$message({
                type: "success",
                message: "Perfil atualizado com sucesso!"
              });
              vm.changePassword = false;
              vm.fetchRecords();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            });
        } else {
          return this.$message({
            type: "error",
            message: "Preencha os campos obrigatórios!"
          });
        }
      });
    },
    fetchExcel() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const arrayExcel = [];

      for (const row of vm.excelData) {
        const o = {
          "Status da Nota": row.status,
          "Status de Pagamento": row.contentStatusPagamento,
          "Criado por": row.users.contact,
          CNPJ: `${row.federalId};`,
          Nota: row.invoice,
          Serie: row.serie,
          Contato: row.contact,
          Fornecedor: row.federalName,
          "Data Emissão": moment(row.issueAt).format("DD/MM/YYYY"),
          "Data Criação": moment(row.createdAt).format("DD/MM/YYYY")
        };

        for (const record of row.items) {
          const unitPrice = Number(record.unitPrice)
            .toFixed(2)
            .replace(".", ",");
          const total = Number(record.total)
            .toFixed(2)
            .replace(".", ",");
          o["Numero do Pedido"] = record.requestNumber;
          o["Filial"] = record.companyBranch;
          o["Item"] = record.item;
          o["Produto"] = record.product;
          o["Qtde Entregue"] = record.delivery;
          o["Quantidade"] = record.quantity;
          o["Preço Unitário"] = unitPrice;
          o["Total"] = total;
          arrayExcel.push({ ...o });
        }
        if (row.items.length == 0) {
          arrayExcel.push(o);
        }
      }

      loading.close();
      return arrayExcel;
    },
    insertStatusOnTable: function(row) {
      if (row.error) {
        row.type = "danger";
        row.status = "Erro";
        row.content = `${row.messageStatus}`;
      } else if (row.integrado) {
        row.type = "success";
        row.status = "Integrado";
        row.content = row.messageStatus || "Nota integrada com sucesso!";
      } else {
        row.type = "info";
        row.status = "A Integrar";
        row.content = row.messageStatus || "Aguardando integração.";
      }
      if (row.statusPagamento) {
        row.typeStatusPagamento = "success";
        row.contentStatusPagamento = "Pago";
      } else {
        row.typeStatusPagamento = "info";
        row.contentStatusPagamento = "A pagar";
      }
    },
    fetchRecords: function() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      // Caso data não for informada.
      if (!vm.formInline.range) {
        this.$message({
          type: "error",
          message: "Informe uma data de inicio e fim."
        });
        return loading.close();
      }

      vm.formInline.range[0].setHours(0, 0, 0, 0);
      vm.formInline.range[1].setHours(23, 59, 59, 999);

      InvoicesService.list(
        vm.formInline.user,
        vm.formInline.branch,
        vm.formInline.filterBy,
        vm.formInline.range[0],
        vm.formInline.range[1],
        vm.getCompanyId()
      )
        .then(response => {
          if (!response.records) {
            vm.tableData = [];
            return this.$message({
              type: "error",
              message: "E-mail Não encontrado no banco!"
            });
          }

          vm.tableData = response.records;

          for (const row of vm.tableData) {
            vm.insertStatusOnTable(row);
          }
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error
          });
        })
        .finally(() => loading.close());
    },
    edit: function(row) {
      const vm = this;
      vm.$router.replace({
        name: "invoice.edit",
        params: { id: row.id }
      });
    },
    changeStatus: function(row) {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      InvoicesService.update({
        id: row.id,
        error: false,
        status: false,
        messageStatus: ""
      })
        .then(() => {
          const index = vm.tableData.findIndex(value => value.id === row.id);
          vm.tableData[index].error = false;
          vm.tableData[index].integrado = false;
          vm.tableData[index].messageStatus = "Aguardando integração";
          vm.insertStatusOnTable(vm.tableData[index]);

          return this.$message({
            type: "success",
            message: "Nota atualizada."
          });
        })
        .catch(error => this.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    },
    remove: function(row) {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      this.$confirm(
        `Confirmar a eliminação da nota  ${row.invoice}?`,
        "Aviso",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "Aviso",
          center: true
        }
      )
        .then(() => {
          if (row.integrado) {
            this.$confirm(
              `Esta nota já está integrada ao Protheus. Deseja realmente deleta-la?`,
              "Aviso",
              {
                confirmButtonText: "Deletar mesmo assim",
                cancelButtonText: "Cancelar",
                type: "error"
              }
            ).then(() => vm.delete(row.id, row.integrado));
          } else {
            vm.delete(row.id, row.integrado);
          }
        })
        .finally(() => loading.close());
    },

    delete: function(id, status) {
      const vm = this;
      InvoicesService.delete(id, status)
        .then(() => {
          setTimeout(() => {
            vm.fetchRecords();
          }, 300);
          this.$message({
            type: "success",
            message: "Nota eliminada com sucesso!"
          });
        })
        .catch(error => {
          vm.$notify.error({
            title: "Erro",
            message: error
          });
        });
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then(response => {
        vm.isAdmin =
          response.user.type === UserTypeEnum.ADMIN ||
          response.user.type === UserTypeEnum.MASTER;
        vm.name = response.user.name;
        vm.changePassword = response.user.changePassword;
        if (!vm.changePassword) {
          vm.fetchRecords();
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>
